import index from '@/views/newReports'

import basicsIndex from '@/views/newReports/basics-reports'
import basicsList from '@/views/newReports/basics-reports/report-list'

import { storage } from '@/services/storage'

var routes = [
	{
		path: '/relatorios',
		name: 'reports',
		component: index,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Relatórios',
			protect: true,
			rules: {
			}
		},
		redirect: { name: 'reports.basics' },
		children: [
			{
				path: 'basicos',
				name: 'reports.basics',
				component: basicsIndex,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' Relatórios - Básicos',
					protect: true,
					infos: {
						name: 'reports.basics',
						title: 'Básicos',
						subtitle: 'Selecione uma Categoria',
					},
				},
				redirect: { name: 'reports.basics.all' },
				children: [
					{
						path: '',
						name: 'reports.basics.all',
						component: basicsList,
						meta: {
							title:
								(storage.get('client_name') || 'Facilita') + ' Relatórios - Básicos Todos',
							protect: true,
							infos: {
								name: 'reports.basics.all',
								title: 'Básicos',
								subtitle: 'Relatórios de Vendas',
							},
							permissions: {
								groups: ['broker', 'manager', 'supervisor'],
								redirect: {name: 'errors.not.unauthorized'},
							},
						},
					},
					// {
					// 	path: ':title',
					// 	name: 'newReports.basics.dynamic',
					// 	component: basicsList,
					// 	meta: {
					// 		title:
					// 			(storage.get('client_name') || 'Facilita') +
					// 			' Relatórios - Básicos',
					// 		protect: true,
					// 		infos: {
					// 			name: 'newReports.basics.dynamic',
					// 			title: 'Básicos',
					// 			subtitle: 'Aguardando informações...',
					// 		},
					// 		permissions: {
					// 			groups: ['broker', 'manager', 'supervisor'],
					// 			redirect: {name: 'errors.not.unauthorized'},
					// 		},
					// 	},
					// },
				],
			},
		],
	},
]

export { routes }
